export const ALISConstants = {
    DISCONNECTED : 'disconnected',
    CONNECTED :'connected',
    ATTRIBUTES :'attributes',
    QUEUE_NAME :'QUEUE_NAME',
    PINV :'PINV',
    PPTNAME : 'PPT-NAME',
    TERMINATED :'terminated',

  }